<template>
  <iRow width="fill">
    <iRow
      gap="small"
      :width="600"
      wrap="nowrap"
      vertical-align="top"
    >
      <iColumn width="hug">
        <iIcon :name="currentIcon" size="large" />
      </iColumn>
      <iColumn gap="large">
        <iColumn gap="none">
          <iRow vertical-align="middle">
            <iHeading font-weight="dark" font-size="large">
              {{ title }}
            </iHeading>
            <iButton
              v-if="isDone && !editing"
              variant="secondary"
              size="small"
              @click="$emit('edit')"
            >
              Edit
            </iButton>
          </iRow>
          <iText variant="subtle">
            {{ description }}
          </iText>
        </iColumn>
        <iColumn gap="large">
          <slot v-if="editing" />
          <template v-else>
            <slot v-if="!isDone" name="pitch" />
            <slot v-else name="summary" />
          </template>
          <iButton v-if="editing" size="small" @click="$emit('done')">
            Done
          </iButton>
        </iColumn>
      </iColumn>
    </iRow>
  </iRow>
</template>

<script>
export default {
  name: "ChecklistItem",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    isDone: { type: Boolean, required: true },
    editing: { type: Boolean, required: true },
  },
  emits: ["edit", "done"],
  computed: {
    currentIcon() {
      if (this.isDone && !this.editing) {
        return "check-circle";
      }
      if (this.editing) {
        return "contract-edit";
      }
      return "pending-actions";
    },
  },
};
</script>

<style scoped lang="scss">
</style>
